module.exports = __webpack_public_path__ + "img/hero-image2.a26af971.png";